import React from 'react';
import { FloatingButtonsDiscord } from './discord/floating-buttons-discord';
import { FloatingButtonsGuide } from './guide/floating-buttons-guide';

export const FloatingButtons: React.FC = () => {
    return (
        <div className="flex flex-row items-center justify-center pr-[7.4rem] vl:fixed vl:bottom-medium vl:right-[10.4rem] vl:z-[999] vl:rounded-[3.1rem] vl:border vl:border-border vl:bg-body/90 vl:pr-0 vl:shadow-strong vl:backdrop-blur-[0.5rem] vl:transition-[border-color] vl:hover:border-brand-secondary xxl:bottom-[10.9rem] xxl:right-medium xxl:flex-col">
            <FloatingButtonsGuide />
            <FloatingButtonsDiscord />
        </div>
    );
};
